// extracted by mini-css-extract-plugin
module.exports = {"block":"Checkbox_block__cCGsk","label":"Checkbox_label__1n7Gr","checked":"Checkbox_checked__2HZED"};